import { memo } from 'react';
import { NumberFormatBase } from 'react-number-format';

import { FormFieldControlledComponent } from '../../../types/fields';
import { Input } from '../Input.component';
import { useDatePattern } from './hooks/useDatePattern';
import { DatePatternInputProps } from './types/DatePatternInputProps';
import { DatePatternProps } from './types/DatePatternProps';

const DatePatternComponent = ({
  datePattern,
  _ref,
  ...props
}: DatePatternInputProps) => {
  const { handleInputKeyDown, handleSetRef, format } = useDatePattern(
    _ref,
    datePattern,
  );

  return (
    <Input asChild id={props.name} placeholder={datePattern} {...props}>
      <NumberFormatBase
        format={format}
        getInputRef={handleSetRef}
        onKeyDown={handleInputKeyDown}
      />
    </Input>
  );
};

export const DatePattern = memo(
  DatePatternComponent,
) as FormFieldControlledComponent<string, DatePatternProps>;

DatePattern.controlled = true;
DatePattern.displayName = 'DatePattern';
